import React, {useState} from "react";
import {createBrowserRouter, createHashRouter, RouterProvider} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ErrorPage from './pages/Error';
import RootLayout from "./pages/RootLayout";
import LoginPage from "./pages/Login";
import ResetPasswordPage from "./pages/ResetPassword";
import PublicRegister from "./pages/PublicRegister";
import PublicPots from "./pages/PublicPots";
import PublicCatches from "./pages/PublicCatches";
import PublicSlideshow from "./pages/PublicSlideshow";
import PublicResults from "./pages/PublicResults";
import AdminRegister from "./pages/AdminRegister";
import AdminCatches from "./pages/AdminCatches";
import AdminResults from "./pages/AdminResults";

import './App.css';
import {signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword} from "@firebase/auth";
import {auth, db} from "./firebase";

function App() {

  const [user, setUser] = useState();

  const handleLogin = (e, email, password) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {    // success
        setUser(userCredential.user)    // update componente state
        window.localStorage.setItem('user', JSON.stringify(userCredential.user));    // update local storage state
        toast.success(`You were successfully logged in as: ${userCredential.user.email}`);    // notify user
      })
      .catch((error) => {    // failure
        console.log(error);    // output error to console for debugging
        toast.error(`An error occurred: ${error}`);    // notify user
      });
  }

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser();
      window.localStorage.setItem('user', JSON.stringify(null));
      toast.success('You were successfully logged out. Please wait to be redirected automatically.');
      delayRefresh();
    }).catch(error => console.log(error))
  }

  const delayRefresh = () => {
    setTimeout(() => {
      console.log('Delaying page refresh...');
      window.location.reload();
    }, 5000);
  }

  const router = createHashRouter([
    {
      path: '/', 
      element: <RootLayout handleLogin={handleLogin} handleLogout={handleLogout}/>, 
      errorElement: <ErrorPage/>,
      children: [
        { path: '/', element: <PublicRegister /> },
        { path: '/login', element: <LoginPage handleLogin={handleLogin} handleLogout={handleLogout} /> },
        { path: '/resetPassword', element: <ResetPasswordPage/> },
        { path: '/public/fishpots', element: <PublicPots /> },
        { path: '/public/results', element: <PublicResults /> },
        { path: '/public/catches', element: <PublicCatches /> },
        { path: '/public/slideshow', element: <PublicSlideshow /> },
      ],
    },
    {
      path: '/admin',
      element: <RootLayout handleLogin={handleLogin} handleLogout={handleLogout}/>,
      errorElement: <ErrorPage/>,
      children: [
        { path: '/admin/register', element: <AdminRegister /> },
        { path: '/admin/catches', element: <AdminCatches /> },
        { path: '/admin/results', element: <AdminResults /> },
      ],
    }
  ]);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer />
    </>
  )  
}

export default App;

